import { render, staticRenderFns } from "./AdminManagementModule.vue?vue&type=template&id=289732c5"
import script from "./AdminManagementModule.vue?vue&type=script&lang=js"
export * from "./AdminManagementModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports